/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  InputLabel,
  Paper,
  Select,
  MenuItem,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getSubCategoryById,
  updateSubCategory,
} from "../../app/services/subcatagoryservice";
import { fetchCategories } from "../../app/services/CategoryService";

const SubCategoryUpdate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [subCategoryName, setSubCategoryName] = useState("");
  const [categoryCode, setCategoryCode] = useState(""); // dropdown value
  const [categories, setCategories] = useState<any[]>([]);
  const [image, setImage] = useState<File | null>(null);
  const [existingImageUrl, setExistingImageUrl] = useState<string>("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch categories + subcategory details
        const [catRes, subRes] = await Promise.all([
          fetchCategories(),
          getSubCategoryById(Number(id)),
        ]);

        setCategories(catRes?.data || []);

        if (subRes?.data) {
          setSubCategoryName(subRes.data.name || "");
          setCategoryCode(subRes.data.category_code || ""); // preselect category
          setExistingImageUrl(subRes.data.image || "");
        }
      } catch (error) {
        toast("Failed to fetch data");
        navigate("/catalog/subcategory");
      }
    };

    if (id) fetchData();
  }, [id, navigate]);

  const handleReset = () => {
    setSubCategoryName("");
    setCategoryCode("");
    setImage(null);
  };

  const handleSubmit = async () => {
    if (!subCategoryName.trim()) {
      toast("SubCategory name is required");
      return;
    }

    if (!categoryCode) {
      toast("Please select a category");
      return;
    }

    const formData = new FormData();
    //formData.append("sub_category_id", String(id)); // ✅ always use ID
    formData.append("name", subCategoryName);
    formData.append("category_id", categoryCode); // ✅ send category_code
    if (image) {
      formData.append("file", image);
    }

    try {
      // Pass ID for update
      const response = await updateSubCategory(Number(id), formData);

      const status = response?.status?.toLowerCase();
      const message = response?.message;

      if (status === "success") {
        toast(message || "SubCategory updated successfully!");
        navigate("/catalog/subcategory");
      } else {
        toast(message || "Failed to update sub-category.");
      }
    } catch (error: any) {
      toast(error?.response?.data?.message || "Failed to update sub-category.");
    }
  };

  // Image preview
  const previewImageUrl = image ? URL.createObjectURL(image) : existingImageUrl;

  return (
    <Box
      minHeight="20vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgcolor="#f9f9f9"
    >
      <Paper
        elevation={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: 4,
          p: 5,
          width: "100%",
          maxWidth: 900,
        }}
      >
        <Typography
          variant="h5"
          fontWeight={700}
          mb={4}
          color="primary"
          textAlign="center"
        >
          Update SubCategory
        </Typography>

        {/* SubCategory Name Input */}
        <Box mb={3}>
          <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
            SubCategory Name <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <TextField
            fullWidth
            size="medium"
            placeholder="Enter sub-category name"
            value={subCategoryName}
            onChange={(e) => setSubCategoryName(e.target.value)}
          />
        </Box>

        {/* Category Dropdown */}
        <Box mb={3}>
          <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
            Select Category <span style={{ color: "red" }}>*</span>
          </InputLabel>
          <Select
            fullWidth
            size="medium"
            value={categoryCode}
            onChange={(e) => setCategoryCode(e.target.value)}
            displayEmpty
          >
            <MenuItem value="">-- Select Category --</MenuItem>
            {categories.map((cat) => (
              <MenuItem key={cat.code} value={cat.code}>
                {cat.name}
              </MenuItem>
            ))}
          </Select>
        </Box>

        {/* Upload Image */}
        <Box mb={3}>
          <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
            Upload Image
          </InputLabel>
          <Button
            component="label"
            variant="outlined"
            size="large"
            startIcon={<UploadFileIcon />}
            sx={{ px: 3, py: 1.5 }}
          >
            Choose File
            <input
              type="file"
              hidden
              accept="image/*"
              onChange={(e) =>
                setImage(e.target.files ? e.target.files[0] : null)
              }
            />
          </Button>
          {image && (
            <Typography variant="body1" mt={1} color="text.secondary">
              Selected: {image.name}
            </Typography>
          )}
        </Box>

        {/* Image Preview */}
        {previewImageUrl && (
          <Box mt={2}>
            <Typography variant="subtitle1" fontWeight={600}>
              Image Preview:
            </Typography>
            <img
              src={previewImageUrl}
              alt="Preview"
              style={{ marginTop: 10, maxWidth: 200, borderRadius: 8 }}
            />
          </Box>
        )}

        {/* Action Buttons */}
        <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
          <Button
            variant="outlined"
            onClick={handleReset}
            sx={{
              px: 4,
              py: 1.2,
              fontWeight: 600,
              borderColor: "#fcb500",
              color: "#fcb500",
              "&:hover": {
                backgroundColor: "#fff8e1",
                borderColor: "#fcb500",
              },
            }}
          >
            Reset
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
              px: 4,
              py: 1.2,
              backgroundColor: "#fcb500",
              color: "#000",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#fbc02d",
              },
            }}
          >
            Update
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default SubCategoryUpdate;
